module.exports = __webpack_public_path__ + "static/media/CSK-horiz-mobile-hover@2x.cee44a81.png";